import { useState, useEffect, useContext } from 'react'
import { enqueueSnackbar } from 'notistack'
import _ from 'lodash'

import { List, ListItem, Typography, Button } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined'
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined'

import { AppContext } from '/providers/app-context'
import { saveClientMainContact } from '../../providers/clients-api'
import Item from './edit-item'
import StyledPaper from '../paper.jsx'

const AccountAdmin = () => {
  const { apiSource, apiKey, processing, setProcessing, client, refreshClient, user } = useContext(AppContext)

  const [editing, setEditing] = useState(false)

  const [clientCopy, setClientCopy] = useState()
  const [nameError, setNameError] = useState("")
  const [emailError, setEmailError] = useState("")
  const [billingEmailError, setBillingEmailError] = useState("")
  const [validity, setValidity] = useState({ main_contact_name: true, main_contact_email: true, billing_email: true })

  useEffect(() => {
    if (clientCopy) {
      setNameError(validity.main_contact_name ? "" : "Contact name is required.")
      setEmailError(validity.main_contact_email ? "" : "Contact email address is required.")
      setBillingEmailError(validity.billing_email ? "" : "Billing email address is required.")
    }
  }, [validity])


  const setClientValue = (field, e) => {

    const isValid = e.target.validity.valid

    let v = _.clone(validity)
    v[field] = isValid
    setValidity(v)

    let c = _.clone(clientCopy)
    c[field] = e.target.value
    setClientCopy(c)
  }

  const edit = () => {
    setEditing(true)
    setClientCopy(_.clone(client))
  }

  const save = async () => {
    setProcessing(true)
    enqueueSnackbar({ message: "Saving Contact Details", variant: 'light' })
    await saveClientMainContact({ apiSource, apiKey, client: clientCopy })
    // TODO Add error handling
    enqueueSnackbar({ message: "Contact Details Saved", variant: 'success' })
    setProcessing(false)

    setEditing(false)
    refreshClient()
  }

  return (

    <div className='flex flex-col h-full items-center justify-center p-20'>
      <StyledPaper>
        <div className='flex flex-col gap-5 p-5'>
          <Typography variant='h4'>
            <div className='flex flex-row gap-20'>
              <div>Contacts</div>
              <Button variant="outlined" startIcon={<EditIcon />} onClick={() => edit()} disabled={processing || !client} sx={{ display: editing ? 'none' : '' }}>Edit</Button>
            </div>
          </Typography>

          <List>

            <Item title="Name" client={client} clientCopy={clientCopy} field="main_contact_name" change={setClientValue} editing={editing} format="text" required={true} error={!validity.main_contact_name} helperText={nameError} />
            <Item title="Email" client={client} clientCopy={clientCopy} field="main_contact_email" change={setClientValue} editing={editing} format="email" required={true} error={!validity.main_contact_email} helperText={emailError} />
            <Item title="Phone" client={client} clientCopy={clientCopy} field="main_contact_phone" change={setClientValue} editing={editing} format="phone" />
            <Item title="Billing email" client={client} clientCopy={clientCopy} field="billing_email" change={setClientValue} editing={editing} format="email" equired={true} error={!validity.billing_email} helperText={billingEmailError} />

            <ListItem sx={{ display: editing ? '' : 'none' }}>
              <div className='flex flex-row justify-between w-full'>
                <Button variant='outlined' startIcon={<CancelOutlinedIcon />} onClick={() => setEditing(false)}>Cancel</Button>
                <Button variant='contained' startIcon={<SaveOutlinedIcon />} onClick={save} disabled={!validity.main_contact_name || !validity.main_contact_email}>Save</Button>
              </div>
            </ListItem>

          </List>
        </div>
      </StyledPaper>

    </div>
  )
}

export default AccountAdmin